var map = {
	"./139_email.png": "e573",
	"./360.png": "5585",
	"./baidu_netdisk.png": "22ab",
	"./beihang_university.png": "978b",
	"./china_oil.png": "3a4e",
	"./de_li.png": "3b4e",
	"./demo_logo.svg": "5355",
	"./hantu.png": "3951",
	"./he_fei_xin.png": "3e11",
	"./huijiao_cloud.png": "cbff",
	"./kdocs_logo.svg": "dc3c",
	"./wps_plus_logo.svg": "277d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db58";